import BasicApiClass from '../classes/BasicApiClass'

export const historialEquivalenciasApi = new BasicApiClass({
    recurso: 'historial-equivalencia',
    recursoMulti: 'historial-equivalencias'
})